import { Stack, Typography } from '@mui/material';
import { AbyssIcon } from '@/assets/icons/AbyssIcon';
import { abyssColors } from '@/theme/colors';

export const NoVersions = () => {
  return (
    <Stack height="100vh" justifyContent="center" alignItems="center">
      <Stack gap={1} alignItems="center">
        <AbyssIcon iconName="versions" style={{ width: '24px', height: '24px', opacity: 0.4 }} />
        <Typography color={abyssColors.primary[500]}>No versions found</Typography>
      </Stack>
    </Stack>
  );
};
